import { useEffect, useState } from "react";
import { useOutletContext, Link } from "react-router-dom";
import api from "@/lib/api";

export default function VendorOverview() {
  const { vendor } = useOutletContext();
  const [stats, setStats] = useState({ products: 0, orders: 0, revenue: 0, pending_approval: 0 });

  useEffect(() => {
    (async () => {
      const [ps, os] = await Promise.all([
        api.get("/vendor/products").then(r => r.data),
        api.get("/vendor/orders").then(r => r.data),
      ]);
      const sales = os.filter(o => !["pending_payment", "cancelled"].includes(o.status));
      const revenue = sales.reduce((s, o) => {
        const mine = o.items.filter(it => it.vendor_id === vendor.id).reduce((a, it) => a + it.price * it.quantity, 0);
        return s + mine;
      }, 0);
      setStats({
        products: ps.length,
        pending_approval: ps.filter(p => !p.approved).length,
        orders: sales.length,
        revenue,
      });
    })();
  }, [vendor.id]);

  const cards = [
    { l: "Products", v: stats.products, s: `${stats.pending_approval} pending approval`, to: "/vendor/products" },
    { l: "Orders", v: stats.orders, s: "Manage dispatches", to: "/vendor/orders" },
    { l: "Revenue", v: `₹ ${stats.revenue.toLocaleString("en-IN")}`, s: "Gross this period", to: "/vendor/analytics" },
    { l: "Failure Rate", v: `${(vendor.failure_rate * 100).toFixed(1)}%`, s: "Flagged if > 5%", to: "/vendor/analytics" },
  ];

  return (
    <div>
      <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{vendor.store_name} · Console</p>
      <h1 className="font-serif text-6xl mt-2 mb-2 tracking-tighter">Overview.</h1>
      <p className="text-muted-foreground max-w-lg mb-10">
        You dispatch directly from your warehouse. Every product is Spotter-inspected at listing time — not per order.
      </p>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
        {cards.map((s) => (
          <Link key={s.l} to={s.to} data-testid={`kpi-${s.l.toLowerCase()}`}
            className="border border-foreground p-6 group hover:bg-foreground hover:text-background transition-colors">
            <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground group-hover:text-background/60">{s.l}</p>
            <p className="font-serif text-4xl mt-2">{s.v}</p>
            <p className="font-mono text-[11px] text-muted-foreground group-hover:text-background/60 mt-2">{s.s}</p>
          </Link>
        ))}
      </div>

      <div className="border border-foreground p-8 tag-punch pl-14">
        <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Workflow</p>
        <h2 className="font-serif text-3xl mt-2 tracking-tighter">How dispatches work</h2>
        <ol className="mt-6 space-y-3 text-sm">
          <li><span className="text-[hsl(var(--accent))] font-mono mr-3">01.</span> List a product → we inspect it once (Skeptic / Perfectionist / Softie).</li>
          <li><span className="text-[hsl(var(--accent))] font-mono mr-3">02.</span> Approved products go live with a Spotter Certificate.</li>
          <li><span className="text-[hsl(var(--accent))] font-mono mr-3">03.</span> On order: you dispatch from your warehouse. Update status in <Link to="/vendor/orders" className="underline">Orders</Link>.</li>
          <li><span className="text-[hsl(var(--accent))] font-mono mr-3">04.</span> Payouts settle weekly at 88/12 split. Track in <Link to="/vendor/payouts" className="underline">Payouts</Link>.</li>
        </ol>
      </div>
    </div>
  );
}
